import React from "react";
import "./SanaviTravels.css";

// const vehicles = [
//   {
//     title: "17 Seater Tempo Traveller",
//     image: "/images/gallery/17-seater-tempo-traveller.jpg",
//     rows: [
//       { type: "Non AC", rate: "₹22/km", minimum: "₹6,600" },
//       { type: "AC", rate: "₹26/km", minimum: "₹7,800" }
//     ]
//   },
//   {
//     title: "20 Seater Tempo Traveller",
//     image: "/images/gallery/20-seater-tempo-traveller.jpg",
//     rows: [
//       { type: "Non AC", rate: "₹25/km", minimum: "₹7,500" },
//       { type: "AC", rate: "₹30/km", minimum: "₹9,000" }
//     ]
//   },
//   {
//     title: "32 Seater Bus",
//     image: "/images/gallery/32-seater-bus.jpg",
//     rows: [
//       { type: "Non AC", rate: "₹35/km", minimum: "₹10,500" },
//       { type: "AC", rate: "₹48/km", minimum: "₹14,400" }
//     ]
//   }
// ];


const vehicles = [
  {
    title: "17 Seater Tempo Traveller",
    image: "/images/gallery/17-seater-tempo-traveller.jpg",
    rows: [
      { type: "Non AC", rate: "₹22/km", minimum: "₹6,600" },
      { type: "AC", rate: "₹26/km", minimum: "₹7,800" }
    ]
  },
  {
    title: "20 Seater Tempo Traveller",
    image: "/images/gallery/20-seater-tempo-traveller.jpg",
    rows: [
      { type: "Non AC", rate: "₹25/km", minimum: "₹7,500" },
      { type: "AC", rate: "₹30/km", minimum: "₹9,000" }
    ]
  },
  {
    title: "32 Seater Bus",
    image: "/images/gallery/32-seater-bus.jpg",
    rows: [
      { type: "Non AC", rate: "₹35/km", minimum: "₹10,500" },
      { type: "AC", rate: "₹48/km", minimum: "₹14,400" }
    ]
  },
  {
    title: "35 Seater Bus",
    image: "/images/gallery/35-seater-bus.jpg",
    rows: [
      { type: "Non AC", rate: "₹38/km", minimum: "₹11,400" },
      { type: "AC", rate: "₹50/km", minimum: "₹15,000" }
    ]
  },
  {
    title: "40 Seater Bus",
    image: "/images/gallery/40-seater-bus.jpg",
    rows: [
      { type: "Non AC", rate: "₹42/km", minimum: "₹12,600" }
    ]
  },
  {
    title: "45 Seater Bus",
    image: "/images/gallery/45-seater-bus.jpg",
    rows: [
      { type: "Non AC", rate: "₹50/km", minimum: "₹15,000" },
      { type: "AC", rate: "₹65/km", minimum: "₹19,500" }
    ]
  }
];


const SanaviTravels = () => {
  const whatsappNumber = "917387507373";

  const handleBookNow = (vehicleName) => {
    const message = `Hello Sanavi Travels,%0A%0AI want to book *${vehicleName}*.%0APlease share details.`;
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <section className="sanavi-container">
      <h2 className="sanavi-heading">Book Travels with Sanavi Travels</h2>

      <div className="card-grid">
        {vehicles.map((vehicle, index) => (
          <div className="vehicle-card" key={index}>
            <div className="image-box">
              <img src={vehicle.image} alt={vehicle.title} />
            </div>

            <h3>{vehicle.title}</h3>

            <table>
              <thead>
                <tr>
                  <th>AC Type</th>
                  <th>Rate per km</th>
                  <th>Daily Minimum (300 KM)</th>
                </tr>
              </thead>
              <tbody>
                {vehicle.rows.map((row, i) => (
                  <tr key={i}>
                    <td>{row.type}</td>
                    <td>{row.rate}</td>
                    <td>{row.minimum}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              className="book-btn"
              onClick={() => handleBookNow(vehicle.title)}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SanaviTravels;
